import axios from 'axios';

axios.defaults.baseURL = "https://linenazi.willwaking.com/server";

axios.interceptors.request.use((config) => {
    if (sessionStorage.getItem("license")) {
        let user = JSON.parse(sessionStorage.getItem("license"))
        config.headers.Authorization = "Bearer " + user.id;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});


let Api = {
    feedback(vm) {
        vm.$message({ message: '服务器端或者客户端网络异常', type: 'warning' });
    },
    login(params) {
        return axios.post('/login', params)
    },
    register(params) {
        return axios.post('/register', params)
    },


    insertChannel(params) {
        return axios.post('/manage/channel/insert', params)
    },
    selectChannel(params) {
        return axios.post('/manage/channel/select', params)
    },
    deleteChannel(params) {
        return axios.post('/manage/channel/delete', params)
    },
    updateChannel(params) {
        return axios.post('/manage/channel/update', params)
    },

    insertRecord(params) {
        return axios.post('/manage/record/insert', params)
    },
    selectRecord(params) {
        return axios.post('/manage/record/select', params)
    },
    deleteRecord(params) {
        return axios.post('/manage/record/delete', params)
    },
    updateRecord(params) {
        return axios.post('/manage/record/update', params)
    },

    insertCloud(params) {
        return axios.post('/manage/cloud/insert', params)
    },
    selectCloud(params) {
        return axios.post('/manage/cloud/select', params)
    },
    deleteCloud(params) {
        return axios.post('/manage/cloud/delete', params)
    },
    updateCloud(params) {
        return axios.post('/manage/cloud/update', params)
    },

    insertAccount(params) {
        return axios.post('/manage/account/insert', params)
    },
    selectAccount(params) {
        return axios.post('/manage/account/select', params)
    },
    deleteAccount(params) {
        return axios.post('/manage/account/delete', params)
    },
    updateAccount(params) {
        return axios.post('/manage/account/update', params)
    },


    insertCertificate(params) {
        return axios.post('/manage/certificate/insert', params)
    },
    selectCertificate(params) {
        return axios.post('/manage/certificate/select', params)
    },
    deleteCertificate(params) {
        return axios.post('/manage/certificate/delete', params)
    },
    updateCertificate(params) {
        return axios.post('/manage/certificate/update', params)
    },

    insertGroup(params) {
        return axios.post('/manage/group/insert', params)
    },
    selectGroup(params) {
        return axios.post('/manage/group/select', params)
    },
    deleteGroup(params) {
        return axios.post('/manage/group/delete', params)
    },
    updateGroup(params) {
        return axios.post('/manage/group/update', params)
    },


    selectInstance(params) {
        return axios.post('/manage/instance/select', params)
    },
    deleteInstance(params) {
        return axios.post('/manage/instance/delete', params)
    },
    updateInstance(params) {
        return axios.post('/manage/instance/update', params)
    },
    insertInstance(params) {
        return axios.post('/manage/instance/insert', params)
    },
}

export default Api;
